module.exports = __webpack_public_path__ + "static/img/choque.497dd9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/iconos/svg/choque.svg
// module id = u/QE
// module chunks = 1